export default {
  appName: 'Fixed Payout Generator',
  appNameShort: 'FPG',
  logoutMinutes: 15,
  nodeUrl: 'https://mainnet-nodes.zp.io',
  nodes: [
    {
      label: 'Mainnet | Remote Node | mainnet-nodes.zp.io',
      value: 'main https://mainnet-nodes.zp.io',
    },
    {
      label: 'Testnet | Remote Node | testnet-nodes.zp.io',
      value: 'test https://testnet-nodes.zp.io',
    },
  ],
  chain: 'main',
  zenJsVersion: process.env.REACT_APP_ZENJS_VERSION || '0.0.0',
  buildVersion: process.env.REACT_APP_BUILD_VERSION || '0.0.0',
  contract: {
    main: process.env.REACT_APP_FP_CONTRACT_ID_MAIN,
    test: process.env.REACT_APP_FP_CONTRACT_ID_TEST,
  },
  contracts: process.env.REACT_APP_FP_CONTRACTS
    ? JSON.parse(process.env.REACT_APP_FP_CONTRACTS)
    : [],
  explorer: {
    main: process.env.REACT_APP_EXPLORER_MAIN || 'https://zp.io',
    test: process.env.REACT_APP_EXPLORER_TEST || 'https://testnet.zp.io',
  },
  contractAssetUrl: {
    main: process.env.REACT_APP_ASSET_NAMING_JSON,
    test: process.env.REACT_APP_ASSET_NAMING_TEST_JSON,
  },
  contractNamingUrl: process.env.REACT_APP_CONTRACT_NAMING_JSON,
  errorReporting: {
    endpoint: process.env.REACT_APP_CONFIG_REPORT_ERRORS_ENDPOINT,
    token: process.env.REACT_APP_CONFIG_REPORT_ERRORS_TOKEN,
    attributes: {
      processType: 'web',
      NODE_ENV: process.env.NODE_ENV,
      zenJsVersion: process.env.REACT_APP_ZENJS_VERSION || 'unknown',
      buildVersion: process.env.REACT_APP_BUILD_VERSION || 'unknown',
      // override for anonymity
      referer: '',
      hostname: '',
    },
  },
};
